import { FolderIcon } from "./icons";

export function EmptyState() {
  return (
    <div className="flex flex-col items-center justify-center gap-3 px-gutter py-16 text-center">
      <FolderIcon className="h-10 w-10 text-surface-border" />
      <p className="max-w-sm text-body text-text-muted">
        This folder is empty. Use Upload to add files or New folder to organize them.
      </p>
    </div>
  );
}
